export default "__VITE_ASSET__cQLf7o$M__"